import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/FinalScore/index";
import { RatingScoreObjectsRight } from "@/src/components/RatingScore/RatingScoreObjectsRight";

const I18n = I18nUtil.createScoped(Translations);

// 参考 RatingScoreCard 的响应式渐变文字（移动端 vs md）
const scoreStyle_text_a =
  "bg-gradient-to-rb from-[#9D7103] via-[#A87900]/50 to-[#9D7103]";
const scoreStyle_text_b =
  "bg-gradient-to-rb from-[#BCB7B7] via-[#606060]/50 to-[#BCB7B7]";
const scoreStyle_text_c =
  "bg-gradient-to-rb from-[#CF814C] via-[#FFD4B1]/50 to-[#CF814C]";
const scoreStyle_text_d = "text-content_secondary";

interface FinalScoreClassNames {
  container?: string;
  leftLaurel?: string;
  rightLaurel?: string;
  content?: string;
  score?: string;
  text?: string;
}

interface FinalScoreProps {
  score: string;
  classNames?: FinalScoreClassNames;
  laurelWidth?: number;
  laurelHeight?: number;
}

type levelStyleItemData = {
  color: string;
  startOpacity: string;
  endOpacity: string;
  text: string;
};

const levelStyleData: Record<string, levelStyleItemData> = {
  A: {
    color: "#FFFFB8",
    startOpacity: "0.5",
    endOpacity: "1",
    text: scoreStyle_text_a,
  },
  B: {
    color: "white",
    startOpacity: "0.5",
    endOpacity: "1",
    text: scoreStyle_text_b,
  },
  C: {
    color: "#FFD4B1",
    startOpacity: "0.5",
    endOpacity: "1",
    text: scoreStyle_text_c,
  },
  D: {
    color: "white",
    startOpacity: "0.3",
    endOpacity: "0.4",
    text: scoreStyle_text_d,
  },
};

const FinalScore: React.FC<FinalScoreProps> = ({
  score,
  classNames = {},
  laurelWidth = 29,
  laurelHeight = 86,
}) => {
  const levelStyle = levelStyleData[score?.split("")[0] || "A"];
  const scoreLevel = (score?.split("")[0] || "A") as "A" | "B" | "C" | "D";
  return (
    <div className={cn("flex", classNames?.container)}>
      {/* Left Laurel */}
      <RatingScoreObjectsRight
        variant={scoreLevel}
        width={laurelWidth}
        height={laurelHeight}
        className={cn(classNames?.leftLaurel)}
      />
      <div
        className={cn(
          "flex flex-col items-center justify-center",
          classNames?.content,
        )}
      >
        <div
          className={cn(
            // A/B/C 需要 bg-clip + transparent 才能显示渐变；D 会由 text-content_secondary 覆盖颜色
            "text-content_brand_primary bg-clip-text text-transparent",
            classNames?.score || "headline_regular_l",
            levelStyle.text,
          )}
        >
          {score}
        </div>

        {/* Final Score Text */}
        <div
          className={cn(
            "text-content_tertiary",
            classNames?.text || "body_medium_m",
          )}
        >
          {I18n.t("Final Score")}
        </div>
      </div>
      {/* Right Laurel */}
      <RatingScoreObjectsRight
        variant={scoreLevel}
        width={laurelWidth}
        height={laurelHeight}
        className={cn("rotate-y-[180deg]", classNames?.rightLaurel)}
      />
    </div>
  );
};

export default FinalScore;
